export const formatUAH = (n) => {
  const num = Math.round(Number(n) || 0);
  return num.toLocaleString('uk-UA').replace(/,/g, ' ') + ' грн';
};

export const cn = (...parts) => parts.filter(Boolean).join(' ');

// Order/product timestamps are stored as naive UTC (datetime.utcnow on the
// server). Render them in Kyiv time so the admin sees the real local moment the
// order was placed — matching the Telegram notification. DST is handled by the
// Intl time zone.
export const formatKyivDateTime = (iso) => {
  if (!iso) return '';
  // Ensure the naive string is parsed as UTC (append Z when it has no offset).
  const s = /[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + 'Z';
  const d = new Date(s);
  if (isNaN(d.getTime())) return String(iso).slice(0, 16).replace('T', ' ');
  return d
    .toLocaleString('uk-UA', {
      timeZone: 'Europe/Kyiv',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    })
    .replace(',', '');
};
